export const methods = {
  remove: 'removeItem',
  update: 'updateItem',
  create: 'createItem',
}

export const defaultPositionKey = 'position'

export const defaultItemSorter = (positionKey) => (a, b) =>
  a[positionKey] - b[positionKey]
